module.exports = __webpack_public_path__ + "static/media/IMG_4294.6b667c07.PNG";